import React from "react";
import { Highlight } from "./highlight";
import { SearchItem } from "./types";

export function SearchTermHitItem({ item, highlightAttribute = "label" }: { item: SearchItem; highlightAttribute: string }) {
  return (
    <div className="aa-ItemWrapper">
      <div className="aa-ItemContent">
        {/* <div className="aa-ItemIcon aa-ItemIcon--picture aa-ItemIcon--alignTop">
                                  <img src={item.image} alt={item.name} width="40" height="40" />
                                </div> */}
        <div className="aa-ItemContentBody">
          <div className="aa-ItemContentTitle">
            <Highlight hit={item} attribute={highlightAttribute} />
          </div>
          {/* <div className="aa-ItemContentDescription">{JSON.stringify(item)}</div> */}
        </div>
      </div>
      <div className="aa-ItemActions">
        <button className="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly" type="button" title="Select" style={{ pointerEvents: "none" }}>
          <svg fill="currentColor" viewBox="0 0 24 24">
            <path d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z" />
          </svg>
        </button>
      </div>
    </div>
  );
}
